import { Accessor, createEffect, createMemo, createSignal, Setter, Signal } from "solid-js";

export type ViewControlType = 'string' | 'time' | 'date' 

export class ViewControlContext<T> {
    dirty: Accessor<boolean>;
    value: Accessor<T>; setValue: Setter<T>;
    oldValue: Accessor<T>; setOldValue: Setter<T>;

    type: ViewControlType;

    constructor(value: Signal<T>, oldValue: Signal<T>, type: ViewControlType = 'string') {
        [this.value, this.setValue] = value;
        [this.oldValue, this.setOldValue] = oldValue;

        this.type = type;
        
        this.dirty = createMemo(() => !this.isEqual(this.value(), this.oldValue()));
    }

    undo() {
        this.setValue(() => this.oldValue());
    }

    private isEqual(a: T | undefined, b: T | undefined): boolean {
        switch (this.type) {
            case 'string':
                return a === b;
            case 'date':
                if (isDate(a) && isDate(b)) {
                    return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
                }
                return a?.toString() === b?.toString();
            case 'time':
                if (isDate(a) && isDate(b)) {
                    return a.getHours() === b.getHours() && a.getMinutes() === b.getMinutes();
                }
                return a?.toString() === b?.toString();
        }
    }
}


const isDate = (value: any): value is Date => value instanceof Date || value?.constructor === Date;